/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bronze_Wild_Ape_BoltInputs */

const en_bronze_wild_ape_bolt = /** @type {(inputs: Bronze_Wild_Ape_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_bronze_wild_ape_bolt = /** @type {(inputs: Bronze_Wild_Ape_BoltInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Bronze_Wild_Ape_BoltInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const bronze_wild_ape_bolt = /** @type {((inputs?: Bronze_Wild_Ape_BoltInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bronze_Wild_Ape_BoltInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_bronze_wild_ape_bolt(inputs)
	return de_bronze_wild_ape_bolt(inputs)
});